import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { type OrderCategory } from './common'
import { MAX_DTS_NOTE_LENGTH } from 'utils/constants'

export const buttonStyle = {
  height: 60,
  width: '100%',
}
export const text = {
  DISCARD_ORDER: 'Discard order',
  CLOSE: 'Close',
  CANCEL: 'Cancel',
  DISCARD_TITLE: 'Order will be discarded',
  DISCARD_WARNING: 'There are items currently in your order. Are you sure you want to discard them?',
  ORDER_SUCCESSFUL: 'Order created successfully',
  ORDER_SUCCESSFUL_MESSAGE: 'The prescription details were submitted to the Support team for processing.',
  ORDER_FAILED: 'Order failed',
  ORDER_FAILED_MESSAGE: 'An error occurred processing the order.',
  RX_CREATED_IN_TREAT: 'Rx Created in Treat',
  RX_CREATED_IN_TREAT_MESSAGE:
    'This order contains a TREAT item, which will require you to log in to treat.com and finalize the order for it to be shipped.',
  COULDNT_CREATE_RX: "Couldn't create Rx",
  COULDNT_CONTACT_TREAT: "Couldn't contact TREAT. Please log in and manually set up the order.",
  COULDNT_CREATE_RX_MESSAGE:
    'This order contains a TREAT item, which will require you to log in to treat.com and set up the order for it to be shipped.',
  OK: 'Ok',
  CONTINUE_TO_TREAT: 'Continue to Treat',
  AUTHORIZE_LATER: 'Authorize later',
}
export function isNoteValid(
  note: string,
  setError: (value: string) => void,
  setNoteError: (value: string) => void,
): boolean {
  if (note && note.length > MAX_DTS_NOTE_LENGTH) {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setError(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'note'))
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setNoteError(getUserFriendlyErrorMessage(errorCodes.MAX_CHARACTER_LIMIT, null, 'Note'))
    return false
  }
  return true
}

export function getDeliveryType(type: OrderCategory): 'pharmacy' | undefined {
  if (type === 'moud') {
    return 'pharmacy'
  }
}
